import { supabase } from "@/integrations/supabase/client";

interface AIConfig {
  temperature?: number;
  max_tokens?: number;
  top_p?: number;
  stream?: boolean;
}

export async function generateMaplePTCompletion(
  messages: Array<{ role: string; content: string | Array<{type: string, text?: string, image_url?: {url: string, detail: string}}> }>,
  model: string,
  config?: AIConfig
): Promise<{ content: string; tokensUsed: number }> {
  const { data, error } = await supabase.functions.invoke('maplept-proxy', {
    body: {
      endpoint: 'chat/completions',
      body: {
        model,
        messages,
        max_tokens: config?.max_tokens ?? 1500,
        temperature: config?.temperature,
        top_p: config?.top_p,
        stream: config?.stream ?? false
      }
    }
  });

  if (error) {
    const message = typeof error.message === 'string' ? error.message : JSON.stringify(error);
    throw new Error(message || 'Failed to get response from MaplePT via proxy');
  }
  if (!data || (data as any).error) {
    const err = (data as any)?.error;
    const message =
      typeof err === 'string'
        ? err
        : typeof err?.message === 'string'
        ? err.message
        : JSON.stringify(err);
    throw new Error(message || 'Failed to get response from MaplePT via proxy');
  }

  const content = data.choices?.[0]?.message?.content ?? '';
  const tokensUsed = data.tokensUsed ?? data.usage?.total_tokens ?? 0;
  return { content, tokensUsed };
}

export async function checkMaplePTConnection(): Promise<boolean> {
  const { data, error } = await supabase.functions.invoke('maplept-proxy', {
    body: { action: 'check_connection' }
  });
  if (error) return false;
  if (!data) return false;
  return Boolean(data.ok);
}